import { TagIcon } from "./TagIcon";
import { ClientTag } from "@avenueops/shared-types";
import { ProcessFilterZod } from "@avenueops/shared-types";
import { Button } from "@avenueops/web-components";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useRouter } from "next/router";
import { pagesPath } from "utils/$path";

interface Props {
  name: string;
  tag?: Pick<ClientTag, "id" | "color" | "dynamicTags">;
  removeTag?: (data: string) => void;
  clickable?: boolean;
  workflowId?: string;
  size?: "MEDIUM" | "SMALL" | "LARGE";
}

export default function TagPill({ name, removeTag, tag, clickable = true, workflowId, size = "MEDIUM" }: Props) {
  const router = useRouter();
  return (
    <div className="w-fit">
      <Button
        onClick={async () => {
          if (!tag || !clickable) return;
          await router.push({
            pathname: pagesPath.signals.$url().pathname,
            query: {
              filters: [JSON.stringify({ type: "TAG", value: [tag.id] } as ProcessFilterZod)],
            },
          });
          router.reload();
        }}
        type="SECONDARY"
        size={size}
      >
        {!tag ? (
          <div className={`${size === "MEDIUM" ? "font-medium text-sm" : "font-medium text-xs"} text-gray-800 truncate`}>{`{{${name}}}`}</div>
        ) : (
          <div className="truncate whitespace-nowrap flex flex-row">
            <TagIcon tag={tag} workflowId={workflowId} />
            <div className={`${size === "MEDIUM" ? "font-medium text-sm" : "font-medium text-xs"} `}>{name}</div>
          </div>
        )}

        {removeTag ? (
          <XMarkIcon
            className="ml-1 h-4 w-4 hover:text-gray-600 text-gray-400 shrink-0"
            onClick={(e) => {
              e.stopPropagation();
              removeTag(tag ? tag.id : name);
            }}
          />
        ) : null}
      </Button>
    </div>
  );
}
